/* eslint-disable handle-callback-err */
/*
  APIアクセスの共通例処理 セッションが無い場合に利用
  バックエンドリソースサーバーへのAPIアクセスはこのライブラリを経由したAxiosを利用する。
*/
import axios from 'axios'
import settings from '@/settings'
import * as utils from '@/library/utils'

// バックエンドAPIのベースURL
const baseUrl = settings.ApiUrl

const http = axios.create({
  baseURL: baseUrl
})

// リクエスト時の共通処理
http.interceptors.request.use((config) => {
  utils.beforeHttpHandler()
  return config
}, function (error) {
  return Promise.reject(error)
})

// レスポンス時の共通処理
http.interceptors.response.use(
  (res) => {
    utils.successHttpHandler()
    return res
  },
  (error) => {
    utils.noSessionErrorHandler(error)
    return Promise.reject(error)
  })

export default http
